<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Gestão de Carga</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <!-- <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('gestaocarga.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('gestaocarga.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li> -->
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'b_arquivo'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    :load-on-start="false"
                    no-data-template="Para retornar algum dado, o usuário deve aplicar os filtros e clicar em filtrar"
                    ref="vuetable"
                    api-url="/api/gestaocarga"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="cargaId"
                    pagination-path="meta"
                    @vuetable:load-error="onError"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="gestaocarga-detalhes"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="numCarga" slot-scope="props">
                      {{ props.rowData.numCarga }}
                    </template>
                    <template slot="dtExpedicao" slot-scope="props">
                      <span v-if="props.rowData.dtExpedicao != null">
                        {{ formatDate(props.rowData.dtExpedicao) }}
                      </span>
                    </template>
                    <template slot="notasFinalizadas" slot-scope="props">
                      {{ props.rowData.qtdNotasFinalizadas }} /
                      <span v-if="props.rowData.qtdTotalNotas > 0">
                        {{ props.rowData.qtdTotalNotas }}  
                      </span>
                      <span v-if="props.rowData.qtdTotalNotas == 0">
                        {{ props.rowData.qtdTotalBipNotas }}
                      </span>
                    </template>
                    <template slot="numRomaneio" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.manifesto != null
                        "
                        >{{
                          props.rowData
                            .manifesto.numFiscal
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.manifesto == null
                        "
                        >{{ props.rowData.numCarga }}</span
                      >
                    </template>
                    <template slot="ciot" slot-scope="props">
                      <span v-if="props.rowData.cargaCiot != null">{{
                        props.rowData.cargaCiot.numCiot
                      }}</span>
                    </template>
                    <template slot="tpOperacaoPrincipal" slot-scope="props">
                      <span v-if="props.rowData.tpOperacaoPrincipal != null && (props.rowData.statusProcessoExpedicao.valor == 2 || props.rowData.statusProcessoExpedicao.valor == 3)">{{
                        props.rowData.tpOperacaoPrincipal.descr
                      }}</span>
                      <span v-if="props.rowData.cargaBipDoc.length > 0 && 
                        props.rowData.statusProcessoExpedicao.valor == 1 &&
                         (props.rowData.statusProcessoExpedicao.valor != 3 && props.rowData.statusProcessoExpedicao.valor != 6)">
                         <span v-if="props.rowData.cargaBipDoc[0].docFiscal.cargaDoc.docCargaDoc.doc.tpOperacaoValor == 3">LM</span>
                         <span v-if="props.rowData.cargaBipDoc[0].docFiscal.cargaDoc.docCargaDoc.doc.tpOperacaoValor != 3">
                          {{props.rowData.cargaBipDoc[0].docFiscal.cargaDoc.docCargaDoc.doc.tpOperacao}}</span>
                         </span>
                      <span v-if="props.rowData.cargaDoc.length > 0 &&
                         props.rowData.statusProcessoExpedicao.valor == 1 &&
                          (props.rowData.statusProcessoExpedicao.valor == 3)">
                          <span v-if="props.rowData.cargaDoc[0].docCargaDoc.doc.tpOperacaoValor == 3">LM</span>
                          <span v-if="props.rowData.cargaDoc[0].docCargaDoc.doc.tpOperacaoValor != 3">
                          {{props.rowData.cargaDoc[0].docCargaDoc.doc.tpOperacao}}</span>
                          </span>
                      </span>
                    </template>
                    <template slot="pesoBruto" slot-scope="props">
                      <span v-if="props.rowData.status.valor == 6 || props.rowData.status.valor == 3">{{
                        formatNumber(props.rowData.pesoBrutoCargaDoc)
                      }}</span>
                      <span v-if="props.rowData.status.valor != 6 && props.rowData.status.valor != 3">{{
                        formatNumber(props.rowData.pesoBrutoCargaBipDoc)
                      }}</span>
                    </template>
                    <template slot="qtdVolume" slot-scope="props">
                      <span v-if="props.rowData.status.valor == 6 || props.rowData.status.valor == 3">
                        {{props.rowData.qtdVolumeBipado }} / {{
                        props.rowData.qtdVolumeCargaDoc
                      }}</span>
                      <span v-if="props.rowData.status.valor != 6 && props.rowData.status.valor != 3">
                        {{props.rowData.qtdVolumeBipado }} / {{
                        props.rowData.qtdVolumeCargaBipDoc
                      }}</span>
                    </template>
                    <template slot="vlrTotalNfs" slot-scope="props">
                      <span v-if="props.rowData.status.valor == 6 || props.rowData.status.valor == 3">{{
                        formatNumber(props.rowData.vlrTotalNfsCargaDoc)
                      }}</span>
                      <span v-if="props.rowData.status.valor != 6 && props.rowData.status.valor != 3">{{
                        formatNumber(props.rowData.vlrTotalNfsCargaBipDoc)
                      }}</span>
                    </template>
                    <template slot="qtdDocs" slot-scope="props">
                      <span v-if="props.rowData.status.valor == 6 || props.rowData.status.valor == 3">{{
                        props.rowData.qtdDocsCargaDoc
                      }}</span>
                      <span v-if="props.rowData.status.valor != 6 && props.rowData.status.valor != 3">{{
                        props.rowData.qtdDocsCargaBipDoc
                      }}</span>
                    </template>
                    <template slot="transportador" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.pessoa != null &&
                          props.rowData.pessoa.pessoaJuridica != null
                        "
                        >{{
                          props.rowData.pessoa.pessoaJuridica.razaoSocial
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.pessoa != null &&
                          props.rowData.pessoa.pessoaFisica != null
                        "
                        >{{ props.rowData.pessoa.pessoaFisica.nome }}</span
                      >
                    </template>
                    <template slot="unidadeParceira" slot-scope="props">
                      <span v-if="props.rowData.pessoaParceira != null">{{
                        props.rowData.pessoaParceira.descr
                      }}</span>
                    </template>
                    <template slot="placaPrimaria" slot-scope="props">
                      <span v-if="props.rowData.cargaMeioTransp != null">{{
                        props.rowData.cargaMeioTransp.placa
                      }}</span>
                    </template>
                    <template slot="motorista" slot-scope="props">
                      <span v-if="props.rowData.cargaMeioTransp != null">{{
                        props.rowData.cargaMeioTransp.nomeMotorista
                      }}</span>
                    </template>
                    <template slot="vlr_frete_despesa" slot-scope="props">
                      <span v-if="props.rowData.vlrFreteDespesa != 0 && props.rowData.vlrDespesaAvulso == null">{{
                        formatNumber(props.rowData.vlrFreteDespesa)
                      }}</span>
                      <span v-if="props.rowData.vlrFreteDespesaAvulso != 0 && props.rowData.vlrDespesaAvulso != null">{{
                        formatNumber(props.rowData.vlrDespesaAvulso)
                      }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 4"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-secundary"
                        v-if="props.rowData.status.valor == 5"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 6"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>

                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <span v-if="getPermissionFw('gestaocarga.status')">
                          <!-- <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a> -->
                        </span>
                        <a
                          @click="onPrintRomaneio(props.rowData)"
                          v-if="
                            props.rowData.tpOperacaoPrincipal != null &&
                            props.rowData.tpOperacaoPrincipal.valor == 3 &&
                            props.rowData.statusProcessoExpedicao.valor == 3
                            && (props.rowData.status.valor == 6 || props.rowData.status.valor == 3)
                          "
                          v-b-tooltip
                          title="Imprimir romaneio"
                          ><i class="fa fa-file"></i
                        ></a>
                        <a
                          @click="onRefazerCalculo(props.rowData.cargaId)"
                          v-b-tooltip
                          v-if="(props.rowData.status.valor == 6 || props.rowData.status.valor == 3)"
                          title="Refazer calculo"
                          ><i class="fa fa-refresh"></i
                        ></a>
                        <a
                          @click="onEstornaCalculo(props.rowData.cargaId)"
                          v-b-tooltip
                          v-if="
                            getPermissionFw('gestaocarga.custo.estornar') &&
                              ((props.rowData.cargaCiot == null && props.rowData.status_expedicao_despesa == 3) ||
                            (props.rowData.cargaCiot != null &&
                              props.rowData.cargaCiot.statusCiot == 2 &&
                              props.rowData.status.valor == 3 && props.rowData.status_expedicao_despesa == 3))
                              && (props.rowData.status.valor == 6 || props.rowData.status.valor == 3)
                          "
                          title="Estornar calculo"
                          ><i class="fa fa-window-close-o"></i
                        ></a>
                        <a
                          @click="onExport(props.rowData.cargaId)"
                          v-b-tooltip
                          v-if="(props.rowData.status.valor == 6 || props.rowData.status.valor == 3)"
                          title="Exportar Docs"
                          ><i class="fa fa-file-code-o"></i
                        ></a>
                        <span
                          v-if="getPermissionFw('gestaocarga.adiantamento') && props.rowData.tpOperacaoPrincipal.valor == 2 && (props.rowData.status.valor == 6 || props.rowData.status.valor == 3)"
                        >
                          <a
                            @click="onAdiantar(props.rowData.cargaId)"
                            v-b-tooltip
                            title="Adiantar Valor"
                            ><i class="fa fa-money"></i
                          ></a>
                        </span>
                        <span
                          v-if="
                            getPermissionFw('gestaocarga.transferenciainterna')
                          "
                        >
                          <a
                            @click="onTransferencia(props.rowData.cargaId) && (props.rowData.status.valor == 6 || props.rowData.status.valor == 3)"
                            v-b-tooltip
                            v-if="(props.rowData.status.valor == 6 || props.rowData.status.valor == 3)"
                            title="Transferencia Interna"
                            ><i class="fa fa-exchange"></i
                          ></a>
                        </span>
                        <a
                          @click="onPrintMinutaCarga(props.rowData)"
                          v-if="
                            props.rowData.statusProcessoExpedicao.valor == 3 &&
                            props.rowData.isTpCalcAvulsoViagem == true &&
                            (props.rowData.status.valor == 6 || props.rowData.status.valor == 3)
                          "
                          v-b-tooltip
                          title="Imprimir Minuta"
                          ><i class="fa fa-file"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GerenciamentoTransporteForm
        ref="gerenciamentotransporteform"
        :metodo="onFilterReset"
        :tabela="'carga'"
        :rota="'gerenciamentotransporte'"
      >
      </GerenciamentoTransporteForm>
      <GerenciamentoTransporteExportacao
        ref="gerenciamentotransporteexportacao"
      />
      <GerenciamentoTransporteAdiantamento
        ref="gerenciamentotransporteadiantamento"
      />
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import GerenciamentoTransporteFilterBar from "./GerenciamentoTransporteFilterBar";
import GestaoCargaFilterBar from "./GestaoCargaFilterBar.vue";
import GerenciamentoTransporteForm from "./GerenciamentoTransporteForm";
import GerenciamentoTransporteDetalhes from "./GerenciamentoTransporteDetalhes";
import GerenciamentoTransporteExportacao from "./GerenciamentoTransporteExportacao.vue";
import GerenciamentoTransporteAdiantamento from "./GerenciamentoTransporteAdiantamento.vue";
import GestaoCargaDetalhes from "./GestaoCargaDetalhes.vue";

Vue.component("gestaocarga-detalhes", GestaoCargaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    GerenciamentoTransporteForm,
    GerenciamentoTransporteExportacao,
    GestaoCargaDetalhes,
    GerenciamentoTransporteAdiantamento,
    "vuetable-filterbar": GestaoCargaFilterBar,
  },
  data() {
    return {
      dataExport: [],
      optionsTpOperacaoPrincipal: [],
      errors_array: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: false,
      showModal: false,
      form: new Form({ num_carga: "", carga_id: "", status: [] }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:numCarga",
          title: "N° Carga",
          sortField: "numCarga",
        },
        {
          name: "obs",
          title: "Obs",
          sortField: "obs",
        },
        {
          name: "__slot:numRomaneio",
          title: "MDFE/N° Romaneio",
          sortField: "numRomaneio",
        },
        {
          name: "__slot:notasFinalizadas",
          title: "NF Finalizadas",
          sortField: "notasFinalizadas",
        },
        {
          name: "__slot:dtExpedicao",
          title: "Dt.Expedição",
        },
        {
          name: "__slot:pesoBruto",
          title: "Tt.Peso",
          sortField: "peso_bruto"
        },
        {
          name: "__slot:qtdVolume",
          title: "Volume Nfs",
          sortField: "peso_bruto"
        },
        {
          name: "__slot:vlrTotalNfs",
          title: "Vlr Nfs"
        },
        {
          name: "__slot:qtdDocs",
          title: "Qtde Docs"
        },
        {
          name: "__slot:placaPrimaria",
          title: "Placa",
          sortField: "placaPrimaria",
        },
        {
          name: "__slot:motorista",
          title: "Motorista",
          sortField: "motorista",
        },
        {
          name: "__slot:ciot",
          title: "Ciot",
          sortField: "ciot",
        },
        {
          name: "__slot:tpOperacaoPrincipal",
          title: "Operacao",
          sortField: "operacao",
        },
        {
          name: "__slot:transportador",
          title: "Transportador",
          sortField: "transportador",
        },
        {
          name: "__slot:unidadeParceira",
          title: "Unidade Parceira",
          sortField: "unidadeParceira",
        },
        {
          name: "__slot:vlr_frete_despesa",
          title: "Vlr.Tt.Frete Des",
          sortField: "vlr_frete_despesa",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.getLivGeral();
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
  },
  created() {
    let self = this;
    this.$events.$on("reloadVuetable", function () {
      self.onFilterReset();
    });
  },
  methods: {
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.cargaId);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.errors_array = "";
      this.errors_array = [];
      this.data_ctes = [];
      //if separados pois a validação de obrigatoriedade dos campos está no backend
      if(data_filter.dtCteIni != ""){
        this.data_ctes.push(data_filter.dtCteIni);
      }
      if(data_filter.dtCteFim != ""){
        this.data_ctes.push(data_filter.dtCteFim);
      }
      this.moreParams = {
        dataCte: this.data_ctes,
        numCarga: data_filter.numCarga,
        dtIni: data_filter.dtIni,
        dtFim: data_filter.dtFim,
        emissor: data_filter.emissor,
        numRomaneio: data_filter.numRomaneio,
        numFiscal: data_filter.numFiscal,
        dtEmiFiscalIni: data_filter.dtEmiFiscalIni,
        dtEmiFiscalFim: data_filter.dtEmiFiscalFim,
        numCte: data_filter.numCte,
        dtCteIni: data_filter.dtCteIni,
        dtCteFim: data_filter.dtCteFim,
        dtEntregaIni: data_filter.dtEntregaIni,
        dtEntregaFim: data_filter.dtEntregaFim,
        dtPreIni: data_filter.dtPreIni,
        dtPreFim: data_filter.dtPreFim,
        motorista: data_filter.motorista,
        placaVeiculo: data_filter.placaVeiculo,
        obs: data_filter.obs,
        consulta_completa: data_filter.consulta_completa,
        transportadora: data_filter.transportadora.pessoa_id,
        status: data_filter.status.value,
        statusAdiantamento: data_filter.statusAdiantamento.value,
        tpOperacaoPrincipal: data_filter.tpOperacaoPrincipal.value,
      };

      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.errors_array = "";
      this.errors_array = [];
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onExport(data) {
      this.$refs.gerenciamentotransporteexportacao.onExport(data);
    },
    onAdiantar(data) {
      this.$refs.gerenciamentotransporteadiantamento.onCreate(data);
    },
    onTransferencia(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form
        .post("/api/gestaocarga/transferenciainterna")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onRefazerCalculo(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form
        .post("/api/gestaocarga/calculo/refazer")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onEstornaCalculo(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form
        .post("/api/gestaocarga/calculo/estornar")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/gestaocarga/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.tp_operacao_principal.forEach((obj) => {
            this.optionsTpOperacaoPrincipal.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    onPrintRomaneio(data) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = data.cargaId;
      this.form
        .post("/api/gestaocarga/romaneio/imprimir")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onPrintMinutaCarga(data) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = data.cargaId;
      this.form
        .post("/api/gestaocarga/calculo/carga/imprimir")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onCreate() {
      this.$refs.gerenciamentotransporteform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.carga_id;
      this.$refs.gerenciamentotransporteform.onEdit(data, index, this.id);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.carga_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.gerenciamentotransporteform.onActivateDesactivate(
        this.helpForm
      );
    },
    onError(errors) {
      // new ReturnApi(response, this, true, true, false);
      new ReturnApi(errors, this, true, null, null, false);

      var errors = errors.response.data.errors;

      this.errors_array = "";
      this.errors_array = [];
      this.form.unidades = [];
      for (var property in errors) {
        if (errors.hasOwnProperty(property)) {
          if (typeof errors[property] === "object") {
            errors[property].forEach((obj) => {
              this.errors_array.push({
                erro: obj,
              });
            });
          }
        }
      }
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
